import { getSentencesStreamUrl, resolveShareUrl } from "../../../constants";

/**
 * Shared loader for the public Film Reel share used by the concept/demo letters (K's feed,
 * M's studio). Resolves the share token, streams the NDJSON transcript, and returns the ONE
 * presigned source-video URL plus every real (non-spacer) clip's timing/thumbnail.
 * IMPORTANT: send ONLY the X-Share-Token header (never the login Bearer) — the backend
 * checks the user first, and a logged-in token would sign S3 URLs against the wrong bucket.
 */

// Production uses the LIVE public share; local dev uses a LOCAL share, because the live
// token doesn't exist in the (separate, wipeable) local DB. If LocalStack ever resets and
// Letter K/M can't load the reel, re-mint the local share for transcript pk=212 with this
// exact token:
//   TranscriptShare.original.get_or_create(token='localfilmreeldemocherryclipz2026',
//       defaults={'transcript': <pk212>, 'created_by': <owner>, 'permission_level': 'export', 'access_type': 'public'})
export const LIVE_SHARE_TOKEN = "pSG_9ZJzNcGeg06EMmIBDQhSPULYEpnoVyYQTM5LJUU";
const LOCAL_SHARE_TOKEN = "localfilmreeldemocherryclipz2026";
export const SHARE_TOKEN =
  typeof window !== "undefined" && window.location.hostname === "localhost"
    ? LOCAL_SHARE_TOKEN
    : LIVE_SHARE_TOKEN;
export const FILM_REEL_SHARE = `/s/${SHARE_TOKEN}`;

export type ReelClip = { id: number; text: string; start: number; end: number; thumb: string };

export async function fetchFilmReel(): Promise<{ videoUrl: string; clips: ReelClip[]; title: string }> {
  const r1 = await fetch(resolveShareUrl(SHARE_TOKEN));
  const b1 = await r1.json().catch(() => ({} as any));
  if (!r1.ok || !b1.valid) throw new Error("share-resolve");
  const r2 = await fetch(`${getSentencesStreamUrl}${b1.transcript_id}/`, { headers: { "X-Share-Token": SHARE_TOKEN } });
  if (!r2.ok) throw new Error("share-stream");
  const text = await r2.text();
  let videoUrl = "";
  const clips: ReelClip[] = [];
  text.split("\n").forEach((line) => {
    if (!line) return;
    let d: any;
    try { d = JSON.parse(line); } catch (e) { return; }
    if (!videoUrl && d.total_rows && d.video) { videoUrl = d.video; return; }
    if (d.type === "sentence" && d.data && !d.data.space) {
      clips.push({ id: d.data.id, text: d.data.sentence || "", start: d.data.start_in, end: d.data.end_in, thumb: d.data.thumbnail || "" });
    }
  });
  if (!videoUrl || !clips.length) throw new Error("share-empty");
  return { videoUrl, clips, title: b1.title || "Film Reel" };
}
